skrilla.directive('ntrcV2SimpleView', function () {
  return {
    templateUrl: 'directives/ntrcV2SimpleView/ntrcV2SimpleView.html',
    scope: {
    },
    controller: function ($scope, searchService, paginationService, queryService) {
      $scope.key = "ntrcV2";


      $scope.reset = function () {
        $scope.query = {
          userId: "",
          accountId: "",
          limit: 20
        };
        $scope.queryXero = {
          firstDate: new Date()
        }
      };
      $scope.reset();


      $scope.searchFinancials = function () {
        paginationService.resetPage($scope.key);
        paginationService.pageQuery(getFinancials, $scope.key);
      }

      $scope.capture = function(){
        searchService.post("ntrcFinancialsV2/test", {}, "Success")
      }

      let getFinancials = function () {
        return searchService.get("ntrcFinancialsV2" + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
          $scope.tableData.data = response.data.result;
          paginationService.setPage($scope.key, paginationService.buildPage(response));
        });
      }

      $scope.tableData = {
        columns: [
          {title: "Count", field: "betCount"},
          {title: "Owed", field: "moniesOwedToClient", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(R) Stakes Intl", field: "racingStakesInternational", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(R) Stakes Local", field: "racingStakesLocal", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(R) Stakes InterState Horses", field: "racingStakesInterstateHorseRacing", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(R) Stakes InterState Harness", field: "racingStakesInterstateHarness", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(R) Stakes InterState Dogs", field: "racingStakesInterstateGreyhound", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(R) Pays Intl", field: "racingPaysInternational", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(R) Pays Local", field: "racingPaysLocal", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(R) Pays InterState Horses", field: "racingPaysInterstateHorseRacing", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(R) Pays InterState Harness", field: "racingPaysInterstateHarness", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(R) Pays InterState Dogs", field: "racingPaysInterstateGreyhound", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(S) Stakes Intl", field: "sportsStakesInternationalCustomers", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(S) Stakes Aus", field: "sportsStakesAustralianCustomers", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(S) Pays Intl", field: "sportsPaysInternationalCustomers", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
          {title: "(S) Pays Aus", field: "sportsPaysAustralianCustomers", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},

          {title: "Start", field: "startTime", filter:{name: 'dateTimeFormatter'}},
          {title: "End", field: "endTime", filter:{name: 'dateTimeFormatter'}},
          {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}},

        ],
        isSkrillaTable: true,
        data: []
      }



    }
  };
});
